import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {GamesService} from '@app/modules/home/tabs/games/services/games.service';
import {User} from '@app/shared/models/user';

@Component({
  selector: 'app-all-games',
  templateUrl: './all-games.component.html',
  styleUrls: ['./all-games.component.scss']
})
export class AllGamesComponent implements OnChanges {

  @Input() public user: User;
  @Input() private selectedDate: Date;

  constructor(public gamesService: GamesService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    const first = changes?.selectedDate?.firstChange;
    this.gamesService.selectedDate = this.selectedDate;
    this.gamesService.loadEvents(first);
  }

  public onLoadMore(): void {
    this.gamesService.loadMoreEvents();
  }

  public deactivateFilterClicked(): void {
    this.gamesService.sexFilter.selectedOptionValue = null;
    this.gamesService.stateFilter.selectedOptionValue = null;
    this.gamesService.loadEvents();
  }
}
